import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ssc-price',
  templateUrl: './price.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PriceComponent {
  @Input()
  public price: number | undefined;
}
